"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[88099],{

/***/ 319326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => [
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F,
  `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
`
]);
const CardHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardBody = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardFooter = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const Card = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, { children, header, footer, className } = _b, props = __objRest(_b, ["children", "header", "footer", "className"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, __spreadValues({
    className: (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeCls */ .c8)("teko-card", className || ""),
    ref
  }, props), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardHeader, {
    className: "teko-card-header"
  }, header), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardBody, {
    className: "teko-card-body"
  }, children), footer && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardFooter, {
    className: "teko-card-footer"
  }, footer));
});
Card.displayName = "Card";




/***/ }),

/***/ 203281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ DiscountFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DiscountFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 12C3 7.03725 7.03725 3 12 3C16.9627 3 21 7.03725 21 12C21 16.9627 16.9627 21 12 21C7.03725 21 3 16.9627 3 12ZM9 7.5C8.17125 7.5 7.5 8.17125 7.5 9C7.5 9.82875 8.17125 10.5 9 10.5C9.82875 10.5 10.5 9.82875 10.5 9C10.5 8.17125 9.82875 7.5 9 7.5ZM13.5001 15C13.5001 15.8287 14.1713 16.5 15.0001 16.5C15.8288 16.5 16.5001 15.8287 16.5001 15C16.5001 14.1712 15.8288 13.5 15.0001 13.5C14.1713 13.5 13.5001 14.1712 13.5001 15ZM9.5302 15.5302C9.23736 15.8231 8.76255 15.8231 8.4697 15.5302C8.17685 15.2374 8.17685 14.7626 8.4697 14.4697L14.4697 8.4697C14.7626 8.17685 15.2374 8.17685 15.5302 8.4697C15.8231 8.76255 15.8231 9.23735 15.5302 9.5302L9.5302 15.5302Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 479709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ DefaultPromotions; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(29921);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Currency/Currency.es.js
var Currency_es = __webpack_require__(853675);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DiscountFilled.es.js
var DiscountFilled_es = __webpack_require__(203281);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/VoucherColored.es.js
var VoucherColored_es = __webpack_require__(526397);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/DetailGifts/DetailGifts.es.js



const DetailGifts = ({
  gifts
}) => /* @__PURE__ */ react.createElement("div", null, gifts.map((gift, index) => /* @__PURE__ */ react.createElement(StyledGift, {
  key: index
}, /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
  height: 32,
  width: 32,
  border: true,
  borderRadius: 2,
  contain: true,
  src: (gift == null ? void 0 : gift.image.src) || ""
})), /* @__PURE__ */ react.createElement(Quantity, null, "x", gift.quantity), /* @__PURE__ */ react.createElement(GiftName, null, gift.name), gift.endAt && /* @__PURE__ */ react.createElement(EndAt, null, gift.endAt))));
const StyledGift = emotion_styled_browser_esm["default"].div`
  display: flex;
  align-items: center;
  padding: 0.25rem 0;
`;
const GiftName = emotion_styled_browser_esm["default"].span`
  margin-left: 0.25rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.75rem;
`;
const EndAt = emotion_styled_browser_esm["default"].span(({ theme }) => `
    color: ${theme == null ? void 0 : theme.colors.pending500};
    margin-left: 0.5rem;
    font-size: 0.75rem;
  `);
const Quantity = emotion_styled_browser_esm["default"].span`
  font-size: 0.75rem;
  color: #848788;
  margin-left: 0.5rem;
`;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/DefaultPromotion/DefaultPromotions.es.js






const DefaultPromotions = ({
  gifts,
  discount,
  vouchers = []
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, discount > 0 && /* @__PURE__ */ react.createElement(Wrapper, null, /* @__PURE__ */ react.createElement("div", {
    style: { width: "8%" }
  }, /* @__PURE__ */ react.createElement(DiscountFilled_es/* DiscountFilled */.i, {
    size: 20,
    color: "primary500",
    style: { marginLeft: "5px" }
  })), /* @__PURE__ */ react.createElement("div", {
    style: { width: "92%" }
  }, (0,i18n_es.t)("Gi\u1EA3m tr\u1EF1c ti\u1EBFp"), " ", /* @__PURE__ */ react.createElement(StyledCurrency, {
    value: discount
  }))), !!gifts.length && /* @__PURE__ */ react.createElement(DetailGifts, {
    gifts
  }), vouchers.map((voucher, index) => /* @__PURE__ */ react.createElement(Wrapper, {
    key: index
  }, /* @__PURE__ */ react.createElement("div", {
    style: { width: "8%" }
  }, /* @__PURE__ */ react.createElement(VoucherColored_es/* VoucherColored */.C, {
    size: 20,
    color: "primary500",
    style: { marginLeft: "5px" }
  })), /* @__PURE__ */ react.createElement("div", {
    style: { width: "92%" }
  }, (0,i18n_es.t)("T\u1EB7ng"), " ", /* @__PURE__ */ react.createElement(Quantity, null, "x", voucher.quantity), " ", /* @__PURE__ */ react.createElement(StyledVoucherName, null, voucher.name)))));
};
const Wrapper = emotion_styled_browser_esm["default"].div`
  margin-top: 2px;
  display: flex;
`;
const StyledCurrency = (0,emotion_styled_browser_esm["default"])(Currency_es/* Currency */.F)`
  margin: 0 4px;
  color: #ed2101;
  font-weight: 500;
`;
const StyledVoucherName = emotion_styled_browser_esm["default"].span`
  color: #ed2101;
  font-weight: 500;
`;




/***/ }),

/***/ 375329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ DetailComboModal; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./components/Loading.tsx
var Loading = __webpack_require__(235904);
// EXTERNAL MODULE: ./hooks/useDetailCombo.tsx
var useDetailCombo = __webpack_require__(554068);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/ProductDetail/ProductVariantsMobile.es.js
var ProductVariantsMobile_es = __webpack_require__(333577);
// EXTERNAL MODULE: ./components/ProductDetail/styles.ts
var styles = __webpack_require__(243290);
// EXTERNAL MODULE: ./components/desktop/organisms/PromotionOption.tsx
var PromotionOption = __webpack_require__(373137);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(842918);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/DefaultPromotion/DefaultPromotions.es.js + 1 modules
var DefaultPromotions_es = __webpack_require__(479709);
// EXTERNAL MODULE: ./components/Quantity.tsx
var Quantity = __webpack_require__(836282);
;// CONCATENATED MODULE: ./components/desktop/organisms/Combo/ChangeProductPropModal.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 1.5rem;\n  max-height: 35rem;\n  overflow: auto;\n  border-bottom: 1px dashed rgb(221, 221, 221);\n  border-top: 1px dashed rgb(221, 221, 221);\n  ::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n  }\n\n  ::-webkit-scrollbar {\n    width: 8px;\n    background-color: #f5f5f5;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: #999;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  padding: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












const ChangeAutogenProductPropModal = (param)=>{
    let { visible , onCloseModal , product: prod , index , onChangeAutogenProduct  } = param;
    var ref, ref1, ref2, ref3;
    const { product , loading , onChangeQuantity , onChangeSelectionPromotionId , onChangeVariant , onFinish , selectionPromotionId ,  } = (0,useDetailCombo/* useAutogenSelectedProduct */.zX)(index, prod);
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
        show: visible,
        onHide: onCloseModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_es/* Card */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader_es/* BlockHeader */.t, {
                    title: (0,i18n.t)("T\xf9y chọn sản phẩm")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Loading/* Loading */.g, {
                    isLoading: loading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperBodyModal, {
                            children: [
                                product === null || product === void 0 ? void 0 : (ref = product.productConfigurations) === null || ref === void 0 ? void 0 : ref.map((config, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVariantsMobile_es/* ProductVariantsMobile */.$, {
                                        configuration: config,
                                        index: index,
                                        onSelectVariant: onChangeVariant
                                    }, config.id)),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperQuantity, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                            level: 3,
                                            color: "#848788",
                                            marginBottom: "s8",
                                            children: (0,i18n.t)("Số lượng")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity/* Quantity */.h, {
                                            setQuantity: (val)=>onChangeQuantity(val),
                                            quantity: (product === null || product === void 0 ? void 0 : product.quantity) || 1,
                                            min: 1,
                                            max: (ref4 = product === null || product === void 0 ? void 0 : product.totalAvailable) !== null && ref4 !== void 0 ? ref4 : undefined
                                        }),
                                        (product === null || product === void 0 ? void 0 : product.totalAvailable) && (product === null || product === void 0 ? void 0 : product.totalAvailable) < 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                            level: 1,
                                            color: "#E6983A",
                                            marginTop: "s8",
                                            children: (0,i18n.t)("Chỉ c\xf2n {{productTotalAvailable}} sản phẩm", {
                                                productTotalAvailable: product === null || product === void 0 ? void 0 : product.totalAvailable
                                            })
                                        })
                                    ]
                                }),
                                !!(product === null || product === void 0 ? void 0 : (ref1 = product.defaultPromotions) === null || ref1 === void 0 ? void 0 : ref1.length) || !!(product === null || product === void 0 ? void 0 : product.saveWithoutSelectionPromotion) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* DefaultPromo */.hB, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Label */.__, {
                                            children: (0,i18n.t)("Bạn sẽ nhận được")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* DefaultPromoContent */.TG, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultPromotions_es/* DefaultPromotions */.G, {
                                                gifts: product === null || product === void 0 ? void 0 : (ref2 = product.gifts) === null || ref2 === void 0 ? void 0 : ref2.map(discovery/* convertGift */.Kx),
                                                discount: (product === null || product === void 0 ? void 0 : product.saveWithoutSelectionPromotion) || 0,
                                                vouchers: product === null || product === void 0 ? void 0 : product.vouchers
                                            })
                                        })
                                    ]
                                }) : null,
                                !!(product === null || product === void 0 ? void 0 : (ref3 = product.selectionPromotions) === null || ref3 === void 0 ? void 0 : ref3.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Divider */.iz, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Label */.__, {
                                            children: (0,i18n.t)("Chọn th\xeam 1 trong những khuyến m\xe3i sau")
                                        }),
                                        product === null || product === void 0 ? void 0 : product.selectionPromotions.map((promo, index)=>{
                                            const { promotion: convertedPromotion  } = (0,discovery/* convertCommonPromotion */.k6)(promo, // @ts-ignore -> I can't give fall back data because I don't understand logic convert
                                            product === null || product === void 0 ? void 0 : product.priceWithoutSelectionPromotion);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionOption/* PromotionOption */.Mo, {
                                                promotion: convertedPromotion,
                                                active: promo.id === selectionPromotionId,
                                                onClick: ()=>onChangeSelectionPromotionId(promo.id === selectionPromotionId ? undefined : promo.id),
                                                productUnitName: product.uomName
                                            }, index);
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperButtonGroup, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                    onClick: onCloseModal,
                                    style: {
                                        paddingLeft: "3rem",
                                        paddingRight: "3rem"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
                                        level: 2,
                                        weight: "medium",
                                        children: (0,i18n.t)("Bỏ qua")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                    onClick: ()=>{
                                        onFinish(onChangeAutogenProduct);
                                        onCloseModal();
                                    },
                                    marginLeft: "s8",
                                    variant: "primary",
                                    paddingLeft: "s32",
                                    paddingRight: "s32",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
                                        level: 2,
                                        weight: "medium",
                                        children: (0,i18n.t)("Ho\xe0n tất")
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const ChangeDynamicProductPropModal = (param)=>{
    let { visible , onCloseModal , payload , onChangeDynamicProduct , selectedProductIdx  } = param;
    var ref, ref1, ref2;
    const { product , loading , onChangeVariant , onFinish  } = (0,useDetailCombo/* useDynamicSelectedProduct */.Hz)({
        payload,
        selectedProductIdx
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
        show: visible,
        onHide: onCloseModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_es/* Card */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader_es/* BlockHeader */.t, {
                    title: (0,i18n.t)("T\xf9y chọn sản phẩm")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Loading/* Loading */.g, {
                    isLoading: loading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperBodyModal, {
                            children: [
                                product === null || product === void 0 ? void 0 : (ref = product.productConfigurations) === null || ref === void 0 ? void 0 : ref.map((config, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVariantsMobile_es/* ProductVariantsMobile */.$, {
                                        configuration: config,
                                        index: index,
                                        onSelectVariant: onChangeVariant
                                    }, config.id)),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperQuantity, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                            level: 3,
                                            color: "#848788",
                                            marginBottom: "s8",
                                            children: (0,i18n.t)("Số lượng")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity/* Quantity */.h, {
                                            disabled: true,
                                            setQuantity: ()=>{},
                                            quantity: (product === null || product === void 0 ? void 0 : product.quantity) || 1,
                                            min: 1,
                                            max: (product === null || product === void 0 ? void 0 : product.totalAvailable) || undefined
                                        }),
                                        (product === null || product === void 0 ? void 0 : product.totalAvailable) && (product === null || product === void 0 ? void 0 : product.totalAvailable) < 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                            level: 1,
                                            color: "#E6983A",
                                            marginTop: "s8",
                                            children: (0,i18n.t)("Chỉ c\xf2n {{totalAvailable}} sản phẩm", {
                                                totalAvailable: product === null || product === void 0 ? void 0 : product.totalAvailable
                                            })
                                        })
                                    ]
                                }),
                                !!(product === null || product === void 0 ? void 0 : (ref1 = product.defaultPromotions) === null || ref1 === void 0 ? void 0 : ref1.length) || !!(product === null || product === void 0 ? void 0 : product.saveWithoutSelectionPromotion) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* DefaultPromo */.hB, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Label */.__, {
                                            children: (0,i18n.t)("Bạn sẽ nhận được")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* DefaultPromoContent */.TG, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultPromotions_es/* DefaultPromotions */.G, {
                                                gifts: product === null || product === void 0 ? void 0 : (ref2 = product.gifts) === null || ref2 === void 0 ? void 0 : ref2.map(discovery/* convertGift */.Kx),
                                                discount: (product === null || product === void 0 ? void 0 : product.saveWithoutSelectionPromotion) || 0,
                                                vouchers: product === null || product === void 0 ? void 0 : product.vouchers
                                            })
                                        })
                                    ]
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperButtonGroup, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                    onClick: onCloseModal,
                                    style: {
                                        paddingLeft: "3rem",
                                        paddingRight: "3rem"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
                                        level: 2,
                                        weight: "medium",
                                        children: (0,i18n.t)("Bỏ qua")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                    onClick: ()=>{
                                        onFinish(onChangeDynamicProduct);
                                        onCloseModal();
                                    },
                                    marginLeft: "s8",
                                    variant: "primary",
                                    paddingLeft: "s32",
                                    paddingRight: "s32",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
                                        level: 2,
                                        weight: "medium",
                                        children: (0,i18n.t)("Ho\xe0n tất")
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const WrapperBodyModal = emotion_styled_browser_esm["default"].div(_templateObject());
const WrapperButtonGroup = emotion_styled_browser_esm["default"].div(_templateObject1());
const WrapperQuantity = emotion_styled_browser_esm["default"].div(_templateObject2());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(591007);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CashColored.es.js
var CashColored_es = __webpack_require__(290184);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/VoucherColored.es.js
var VoucherColored_es = __webpack_require__(526397);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DownOutlined.es.js
var DownOutlined_es = __webpack_require__(925810);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/GiftColored.es.js
var GiftColored_es = __webpack_require__(971219);
// EXTERNAL MODULE: ./contexts/ScreenContext.tsx
var ScreenContext = __webpack_require__(933756);
// EXTERNAL MODULE: ../../packages/tracking/dist/cart.es.js
var cart_es = __webpack_require__(446586);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Currency/Currency.es.js
var Currency_es = __webpack_require__(853675);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
;// CONCATENATED MODULE: ./components/desktop/organisms/Combo/DetailComboModal.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function DetailComboModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DetailComboModal_templateObject() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 1.5rem;\n  max-height: 35rem;\n  overflow: auto;\n  border-bottom: 1px dashed rgb(221, 221, 221);\n  border-top: 1px dashed rgb(221, 221, 221);\n  ::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n  }\n\n  ::-webkit-scrollbar {\n    width: 8px;\n    background-color: #f5f5f5;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: #999;\n  }\n"
    ]);
    DetailComboModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DetailComboModal_templateObject1() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n"
    ]);
    DetailComboModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DetailComboModal_templateObject2() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  padding: 16px 0;\n  border-bottom: 1px dashed #e4e5f0;\n  &.last-item {\n    border-bottom: none;\n  }\n  &.first-item {\n    padding-top: 0;\n  }\n"
    ]);
    DetailComboModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 6;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  max-width: 80px;\n  margin: unset;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 4;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding-left: 24px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  background-color: #f8f8fc;\n  padding: 12px 12px 0;\n  margin-top: 16px;\n  border-radius: 8px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding-bottom: 12px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  padding-top: 16px;\n  border-top: 1px solid #e4e5f0;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = DetailComboModal_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = DetailComboModal_taggedTemplateLiteral([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}













const DetailComboModal = (_param)=>{
    var { visible , onCloseModal , onAddToCart , type , loading =false  } = _param, rest = _objectWithoutProperties(_param, [
        "visible",
        "onCloseModal",
        "onAddToCart",
        "type",
        "loading"
    ]);
    var ref, ref1;
    const { 0: visibleUpdateProduct , 1: setVisibleUpdateProduct  } = (0,react.useState)(false);
    const { 0: selectedIdx , 1: setSelectedIdx  } = (0,react.useState)();
    const { products , supplierRetailPrice , latestPrice , onChangeQuantity , comboPromotion , onFinish , loadingCombo , onChangeAutogenProduct , onChangeDynamicProduct , payloadCombo ,  } = (0,useDetailCombo/* useDetailCombo */.JC)(type, rest);
    const { trackingScreenName  } = (0,ScreenContext/* useScreen */.EV)();
    const renderProductItemDiscount = function(discount) {
        let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "md";
        if (!discount) return null;
        let text;
        if (discount.percent) {
            text = /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Body */.uT, {
                level: 1,
                children: [
                    (0,i18n.t)("Giảm"),
                    discount.percent,
                    "%",
                    " ",
                    discount.maxAmount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            (0,i18n.t)("tối đa"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Currency_es/* Currency */.F, {
                                marginRight: "s4",
                                value: discount.maxAmount
                            })
                        ]
                    }) : "",
                    (0,i18n.t)(" khi mua combo")
                ]
            });
        } else {
            text = /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Body */.uT, {
                level: 1,
                className: "att-detail-combo-promotion-discount-flag",
                children: [
                    (0,i18n.t)("Giảm trực tiếp"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Currency_es/* Currency */.F, {
                        value: discount.flat
                    }),
                    (0,i18n.t)(" khi mua combo")
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPromotion, {
            style: {
                fontSize: size === "md" ? 13 : 12,
                lineHeight: size === "md" ? "20px" : "16px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperIcon, {
                    size: size === "md" ? 40 : 32,
                    bgColor: "#E7FBED",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CashColored_es/* CashColored */.B, {
                        size: 24
                    })
                }),
                text
            ]
        });
    };
    const renderProductItemGifts = function(gifts) {
        let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "md", quantity = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        return gifts.map((gift)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPromotion, {
                style: {
                    fontSize: size === "md" ? 13 : 12,
                    lineHeight: size === "md" ? "20px" : "16px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperIcon, {
                        size: size === "md" ? 40 : 32,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            src: gift.imageUrl,
                            width: size === "md" ? 40 : 32,
                            imageWidth: 100,
                            height: size === "md" ? 40 : 32,
                            borderRadius: 4,
                            contain: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Body */.uT, {
                        level: 1,
                        children: [
                            gift.quantity * quantity,
                            " x ",
                            gift.name
                        ]
                    })
                ]
            }, gift.sku));
    };
    const renderProductItemVouchers = function(vouchers) {
        let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "md", quantity = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        return vouchers.map((voucher)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPromotion, {
                style: {
                    fontSize: size === "md" ? 13 : 12,
                    lineHeight: size === "md" ? "20px" : "16px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperIcon, {
                        size: size === "md" ? 40 : 32,
                        bgColor: "#FFF2F0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherColored_es/* VoucherColored */.C, {
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Body */.uT, {
                        level: 1,
                        children: [
                            voucher.quantity * quantity,
                            " x ",
                            voucher.name
                        ]
                    })
                ]
            }, voucher.name));
    };
    const handleAddToCart = async ()=>{
        await onFinish(onAddToCart);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
        show: visible,
        onHide: onCloseModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_es/* Card */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader_es/* BlockHeader */.t, {
                    title: (0,i18n.t)("Chi tiết combo")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Loading/* Loading */.g, {
                    isLoading: loadingCombo || loading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailComboModal_WrapperBodyModal, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    products.map((product, index, list)=>{
                                        const { selectedVariant , allowSelectPromotion , latestPrice: latestPriceProduct , supplierRetailPrice: supplierRetailPriceProduct , gifts , vouchers , image , sku , quantity , totalAvailable , name ,  } = product;
                                        const textVariant = selectedVariant.join(" | ");
                                        const showTextSelectPromotion = !textVariant && allowSelectPromotion;
                                        const hasPromotions = !!gifts.length || !!vouchers.length;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProduct, {
                                            className: "".concat(index === list.length - 1 ? "last-item" : "", " ").concat(index === 0 ? "first-item" : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductInfo, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductInfoLeft, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductImage, {
                                                                    src: image,
                                                                    width: 80,
                                                                    imageWidth: 150,
                                                                    height: 80,
                                                                    borderRadius: 4,
                                                                    contain: true
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        marginLeft: 12
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                                                            level: 1,
                                                                            line: 2,
                                                                            className: "att-detail-combo-product-name-".concat(index),
                                                                            children: name
                                                                        }),
                                                                        !!textVariant || showTextSelectPromotion ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantWrapper, {
                                                                            onClick: ()=>{
                                                                                (0,cart_es/* trackManually */.gu)("updateProduct", "productComboDetail", trackingScreenName || "ProductDetail", JSON.stringify({
                                                                                    sku,
                                                                                    screenName: trackingScreenName,
                                                                                    index,
                                                                                    skus: products.map((el)=>el.sku),
                                                                                    promotioinId: comboPromotion === null || comboPromotion === void 0 ? void 0 : comboPromotion.id,
                                                                                    type
                                                                                }));
                                                                                setSelectedIdx(index);
                                                                                setVisibleUpdateProduct(true);
                                                                            },
                                                                            children: [
                                                                                !!textVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                                                                    marginRight: "s4",
                                                                                    color: "#82869E",
                                                                                    children: textVariant
                                                                                }),
                                                                                showTextSelectPromotion && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                                                                    marginRight: "s4",
                                                                                    color: "#82869E",
                                                                                    children: (0,i18n.t)("Chọn khuyến mại")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                                                                                    size: 18
                                                                                })
                                                                            ]
                                                                        }) : null
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductInfoRight, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity/* Quantity */.h, {
                                                                    disabled: type === "dynamic",
                                                                    setQuantity: (val)=>onChangeQuantity(sku, val),
                                                                    quantity: quantity,
                                                                    min: 1,
                                                                    max: totalAvailable || undefined
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperPrices, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice_es/* ProductPrice */.j, {
                                                                        latestPrice: latestPriceProduct,
                                                                        supplierRetailPrice: supplierRetailPriceProduct,
                                                                        textColor: "#434657",
                                                                        className: "att-detail-combo-product-price-".concat(index)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                hasPromotions && /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperPromotions, {
                                                    children: [
                                                        renderProductItemGifts(gifts, "sm", quantity),
                                                        renderProductItemVouchers(vouchers, "sm", quantity)
                                                    ]
                                                })
                                            ]
                                        }, index);
                                    }),
                                    comboPromotion ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledComboPromotion, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledComboPromotionTitle, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftColored_es/* GiftColored */.x, {
                                                        size: 24
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                                        level: 2,
                                                        weight: "medium",
                                                        marginLeft: "s4",
                                                        children: (0,i18n.t)("Qu\xe0 tặng k\xe8m")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperPromotions, {
                                                style: {
                                                    marginTop: 8,
                                                    padding: "16px 16px 0"
                                                },
                                                children: [
                                                    renderProductItemDiscount(comboPromotion.benefit.discount),
                                                    renderProductItemGifts(comboPromotion.benefit.gifts || []),
                                                    renderProductItemVouchers(((ref = comboPromotion.benefit) === null || ref === void 0 ? void 0 : (ref1 = ref.voucher) === null || ref1 === void 0 ? void 0 : ref1.name) ? [
                                                        comboPromotion.benefit.voucher
                                                    ] : [])
                                                ]
                                            })
                                        ]
                                    }) : null,
                                    (!selectedIdx || !!products[selectedIdx]) && type === "autogen" ? selectedIdx !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeAutogenProductPropModal, {
                                        index: selectedIdx,
                                        product: products[selectedIdx],
                                        visible: visibleUpdateProduct && type === "autogen",
                                        onChangeAutogenProduct: onChangeAutogenProduct,
                                        onCloseModal: ()=>{
                                            setVisibleUpdateProduct(false);
                                            setSelectedIdx(undefined);
                                        }
                                    }) : null,
                                    selectedIdx !== undefined && !!products[selectedIdx] && type === "dynamic" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeDynamicProductPropModal, {
                                        selectedProductIdx: selectedIdx,
                                        visible: visibleUpdateProduct && type === "dynamic",
                                        onChangeDynamicProduct: onChangeDynamicProduct,
                                        payload: payloadCombo,
                                        onCloseModal: ()=>{
                                            setVisibleUpdateProduct(false);
                                            setSelectedIdx(undefined);
                                        }
                                    }) : null
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailComboModal_WrapperButtonGroup, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice_es/* ProductPrice */.j, {
                                    size: "l",
                                    supplierRetailPrice: supplierRetailPrice,
                                    latestPrice: latestPrice || "",
                                    className: "att-detail-combo-grandtotal"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                            onClick: onCloseModal,
                                            style: {
                                                paddingLeft: "3rem",
                                                paddingRight: "3rem"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
                                                level: 2,
                                                weight: "medium",
                                                children: (0,i18n.t)("Bỏ qua")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddComboButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                                            isTrackContent: true,
                                            regionName: "productComboDetail",
                                            contentName: "addToCart",
                                            target: trackingScreenName,
                                            payload: JSON.stringify({
                                                skus: products.map((el)=>el.sellerSku),
                                                promotionId: rest.promotionId,
                                                screenName: trackingScreenName,
                                                type
                                            })
                                        })), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                                onClick: ()=>handleAddToCart(),
                                                marginLeft: "s8",
                                                variant: "primary",
                                                paddingLeft: "s32",
                                                paddingRight: "s32",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
                                                    level: 2,
                                                    weight: "medium",
                                                    children: (0,i18n.t)("Th\xeam v\xe0o giỏ")
                                                })
                                            })
                                        }))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const DetailComboModal_WrapperBodyModal = emotion_styled_browser_esm["default"].div(DetailComboModal_templateObject());
const DetailComboModal_WrapperButtonGroup = emotion_styled_browser_esm["default"].div(DetailComboModal_templateObject1());
const StyledProduct = emotion_styled_browser_esm["default"].div(DetailComboModal_templateObject2());
const StyledProductInfo = emotion_styled_browser_esm["default"].div(_templateObject3());
const StyledProductInfoLeft = emotion_styled_browser_esm["default"].div(_templateObject4());
const StyledProductImage = (0,emotion_styled_browser_esm["default"])(LazyImage_es/* LazyImage */.w)(_templateObject5());
const StyledProductInfoRight = emotion_styled_browser_esm["default"].div(_templateObject6());
const WrapperPrices = emotion_styled_browser_esm["default"].div(_templateObject7());
const VariantWrapper = emotion_styled_browser_esm["default"].div(_templateObject8());
const WrapperPromotions = emotion_styled_browser_esm["default"].div(_templateObject9());
const StyledPromotion = emotion_styled_browser_esm["default"].div(_templateObject10());
const WrapperIcon = emotion_styled_browser_esm["default"].div((param)=>{
    let { bgColor , size  } = param;
    return "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ".concat(bgColor || "unset", ";\n  width: ").concat(size, "px;\n  height: ").concat(size, "px;\n  margin-right: 8px;\n  border-radius: 4px;\n");
});
const StyledComboPromotion = emotion_styled_browser_esm["default"].div(_templateObject11());
const StyledComboPromotionTitle = emotion_styled_browser_esm["default"].div(_templateObject12());
const AddComboButtonWrapper = emotion_styled_browser_esm["default"].div(_templateObject13());


/***/ }),

/***/ 627735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useCartCombo; }
/* harmony export */ });
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(534090);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

const useCartCombo = (mainSku)=>{
    const { onAddMultipleItems , onAddComboItems  } = (0,contexts__WEBPACK_IMPORTED_MODULE_0__/* .useCartV2 */ .T6)();
    const onAddComboToCart = !mainSku ? null : async function(type, payload) {
        let override = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        if (type === "autogen") {
            const body = payload.comboLineItems.map((item)=>_objectSpreadProps(_objectSpread({}, item), {
                    promotionId: item.selectPromotionId
                }));
            await onAddMultipleItems(body);
        } else {
            const mainPayload = {
                override,
                groups: [
                    {
                        quantity: 1,
                        promotionId: payload.promotionId,
                        products: payload.comboLineItems.map((el, index)=>({
                                sku: el.sku,
                                quantity: el.quantity,
                                isPrimary: index === 0
                            }))
                    }, 
                ]
            };
            await onAddComboItems(mainPayload, false);
        }
    };
    return {
        onAddComboToCart
    };
};


/***/ })

}]);